import React from 'react';
import { withStyles } from 'tss-react/mui';
import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const HtmlTooltip = withStyles(Tooltip, (theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(6),
    padding: '2em',
    border: '1px solid #dadde9',
  },
}));

export const InvitationTooltip = () => {
  return (
    <>
      <HtmlTooltip
        placement="left-start"
        title={
          <>
            <Typography color="inherit">
              If you have a discount coupon/code please go through the payment
              link. This is only for valid for GekkoVet Staff.
            </Typography>
          </>
        }
      >
        <HelpIcon
          color="primary"
          fontSize="small"
          style={{ cursor: 'pointer' }}
        />
      </HtmlTooltip>
    </>
  );
};
